// Tilt of a node from its accelerometer axes (in g), as the angle between the node's Z axis and
// gravity.
//
// The firmware's own `tilt` field is acos(|az|) with az clamped to 1 g. Whenever the Z axis reads
// 1 g or more (sensor scale/offset) the clamp turns a small tilt into exactly 0.0, so the field
// cannot show a node slowly leaning over. atan2(hypot(ax, ay), |az|) uses all three axes, does not
// saturate, and does not depend on the reading's overall magnitude. |az| keeps a node mounted
// upside down level at 0 degrees, the same convention as the firmware.

const isAxis = (value) => typeof value === "number" && Number.isFinite(value);

/** Tilt in degrees rounded to one decimal, or null when an axis is missing or the reading is empty. */
export function tiltFromAxes(ax, ay, az) {
  if (!isAxis(ax) || !isAxis(ay) || !isAxis(az)) return null;
  // All three at zero is no reading at all, not a level node.
  if (ax === 0 && ay === 0 && az === 0) return null;
  const degrees = (Math.atan2(Math.hypot(ax, ay), Math.abs(az)) * 180) / Math.PI;
  return Math.round(degrees * 10) / 10;
}

/** The tilt with exactly one decimal ("0.0", "7.2"), or null when it cannot be computed. */
export function formatTilt(degrees) {
  return isAxis(degrees) ? degrees.toFixed(1) : null;
}
